import React from 'react';
import {Smartphone, Monitor, Apple} from 'lucide-react';
import section from '../../styles/components/sections.module.css';
import styles from '../../styles/components/DownloadCTASection.module.css';

const DownloadCTASection: React.FC = () => {
  return (
    <section className={section.section}>
      <div className={section.container}>
        <h2 className={section.title}>Ready to Play?</h2>
        <p className={section.subtitle}>Available on iOS, Android, and Web.</p>
        <div className={styles.platforms}>
          <a
            href="https://apps.apple.com/app/id123456789"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.platformBtn}
          >
            <Apple size={20} /> App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.arithmeticblitz"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.platformBtn}
          >
            <Smartphone size={20} /> Google Play
          </a>
          <a href="/" className={styles.platformBtn}>
            <Monitor size={20} /> Play on Web
          </a>
        </div>
      </div>
    </section>
  );
};

export default DownloadCTASection;
